import type { MouseEvent } from 'react';

type Props = {
  itemId: string;
  isFavorite: boolean;
  disabled?: boolean;
  onToggle: (itemId: string) => void;
};

/** Canonical ♡ / ♥ control — does not intercept parent «Открыть» navigation. */
export const FeedFavoriteButton = ({ itemId, isFavorite, disabled, onToggle }: Props) => {
  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    event.stopPropagation();
    if (!disabled) onToggle(itemId);
  };

  return (
    <button
      type="button"
      className={`feed-fav-btn${isFavorite ? ' is-on' : ''}`}
      aria-label={isFavorite ? 'Убрать из избранного' : 'Сохранить в избранное'}
      aria-pressed={isFavorite}
      disabled={disabled}
      onClick={handleClick}
    >
      {isFavorite ? '♥' : '♡'}
    </button>
  );
};
